import { createIcon } from '../createIcon.tsx';
import { FilledIconWrapper } from '../IconWrapper.tsx';
import type { IconProps } from '@federa/types/ui-icons';

const BOOKMARK_PATH = 'M19 21l-7-5-7 5V5a2 2 0 0 1 2-2h10a2 2 0 0 1 2 2z';

export const BookmarkIcon = createIcon('BookmarkIcon', <path d={BOOKMARK_PATH} />);

export function BookmarkIconFilled(props: IconProps) {
	return (
		<FilledIconWrapper {...props}>
			<path d={BOOKMARK_PATH} />
		</FilledIconWrapper>
	);
}
